import { type UploadedImage } from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';
import { type WritableDraft } from 'immer';
import { createContext } from 'react';

const UploadedImagesContext = createContext<{
  images: UploadedImage[];
  imagesEndpoint: string;
  addImageToLocalState: (image: UploadedImage) => void;
  updateImageInLocalState: (
    image: UploadedImage,
    stateUpdater: (image: WritableDraft<UploadedImage>) => void,
  ) => void;
  removeImageFromLocalState: (image: UploadedImage) => void;
}>({
  images: [],
  imagesEndpoint: '',
  addImageToLocalState: dummyFunction,
  updateImageInLocalState: dummyFunction,
  removeImageFromLocalState: dummyFunction,
});

export default UploadedImagesContext;
